// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2wnKC","col":"styles_col__Udjm_"};